<script setup lang="ts">
import type { PropType } from 'vue'
import HomeFloatingBoxAnimation from '~/layers/homepage/components/box/HomeFloatingBoxAnimation.vue'
import type { THomeSectionAnimation } from '~/layers/homepage/data/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionAnimation>,
    required: true,
  },
})
</script>

<template>
  <p class="fixed-panel__text-center">
    {{ section.title }}
  </p>
  <div
    class="main__picture"
    :class="{ 'main__picture_square': section.isSquad }"
  >
    <URemotePicture :picture="section.picture" :isLazy="false" />
  </div>
  <HomeFloatingBoxAnimation :section />
</template>
